module.exports = __webpack_public_path__ + "img/life-illustraition.eb49b922.png";